export const heroSlides = [
  {
    id: 'hero-1',
    title: '顶流网红深夜直播翻车，百万粉丝瞬间脱粉回踩',
    excerpt: '知名带货主播在直播间因不当言论引发全网热议，品牌方连夜解约，账号遭平台限流处理',
    category: '网红塌房',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20artistic%20abstract%20composition%20with%20deep%20crimson%20and%20dark%20charcoal%20tones%2C%20fractured%20geometric%20shapes%20suggesting%20digital%20collapse%2C%20moody%20atmospheric%20lighting%20with%20subtle%20golden%20streaks%2C%20contemporary%20editorial%20design%20aesthetic%20for%20entertainment%20news%2C%20high%20contrast%20dramatic%20visual%2C%20dark%20warm%20gradient%20background%20with%20scattered%20luminous%20particles%2C%20cinematic%20quality%2C%20no%20text%20or%20lettering&width=1920&height=1080&seq=hero-slide-01&orientation=landscape',
    date: '2026-07-07',
  },
  {
    id: 'hero-2',
    title: '年度最大反转！曾被群嘲的博主晒出证据链打脸全网',
    excerpt: '沉寂半年的美食博主放出完整聊天记录与转账凭证，剧情反转引发二次吃瓜热潮',
    category: '每日大赛',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20digital%20artwork%20with%20warm%20amber%20and%20deep%20burgundy%20colors%2C%20overlapping%20translucent%20layers%20creating%20depth%20and%20mystery%2C%20dynamic%20flowing%20shapes%20suggesting%20revelation%20and%20truth%20emerging%2C%20modern%20editorial%20style%2C%20soft%20dramatic%20lighting%20with%20warm%20golden%20glow%2C%20rich%20textural%20abstract%20background%2C%20sophisticated%20visual%20narrative%20without%20any%20text&width=1920&height=1080&seq=hero-slide-02&orientation=landscape',
    date: '2026-07-06',
  },
  {
    id: 'hero-3',
    title: '某千万粉颜值博主真实颜值曝光，滤镜前后判若两人',
    excerpt: '线下活动生图流出，与社交平台精修照差距巨大，网友直呼"诈骗级别"',
    category: '博主反差',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20split%20warm%20coral%20and%20cool%20dark%20tones%2C%20glitch%20effect%20style%20geometric%20disruption%20suggesting%20digital%20manipulation%2C%20contemporary%20editorial%20art%20direction%2C%20dramatic%20contrast%20between%20soft%20pastels%20and%20harsh%20dark%20shadows%2C%20conceptual%20visual%20representing%20duality%20and%20revelation%2C%20no%20text%20visible%2C%20cinematic%20atmospheric%20quality&width=1920&height=1080&seq=hero-slide-03&orientation=landscape',
    date: '2026-07-05',
  },
];

export const dailyContestArticles = [
  {
    id: 'dc-1',
    title: '某音千万网红被曝私下辱骂粉丝录音曝光',
    category: '网红塌房',
    description: '录音长达8分钟，内容令人震惊',
    views: '1280万',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20artistic%20still%20life%20with%20warm%20crimson%20and%20shadow%20tones%2C%20single%20dramatic%20spotlight%20effect%20on%20dark%20background%2C%20contemporary%20editorial%20photography%20style%2C%20moody%20and%20mysterious%20atmosphere%2C%20clean%20simple%20composition%2C%20soft%20gradient%20shadows%2C%20sophisticated%20visual%20for%20entertainment%20news%2C%20no%20text%20or%20people&width=600&height=600&seq=daily-01&orientation=squarish',
  },
  {
    id: 'dc-2',
    title: '两大顶流博主隔空互怼，聊天截图泄露',
    category: '每日大赛',
    description: '截图内容信息量巨大，涉及多位圈内人士',
    views: '965万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20amber%20and%20deep%20charcoal%20colors%2C%20two%20contrasting%20geometric%20forms%20in%20dynamic%20tension%2C%20modern%20editorial%20art%20style%2C%20dramatic%20warm%20lighting%20from%20diagonal%20angle%2C%20sophisticated%20minimalist%20design%2C%20conceptual%20visual%20of%20conflict%20and%20confrontation%2C%20no%20text%20or%20lettering&width=600&height=600&seq=daily-02&orientation=squarish',
  },
  {
    id: 'dc-3',
    title: '知名情侣博主被曝早已分手，各自新恋情',
    category: '网红塌房',
    description: '知情人士爆料两人半年前已分手，各自已有新欢',
    views: '2100万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20split%20warm%20rose%20and%20cool%20slate%20tones%2C%20fractured%20heart-shaped%20geometric%20suggestion%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20soft%20dramatic%20lighting%20with%20emotional%20depth%2C%20elegant%20minimalist%20composition%2C%20conceptual%20art%20representing%20separation%2C%20no%20text%20or%20people&width=600&height=600&seq=daily-03&orientation=squarish',
  },
  {
    id: 'dc-4',
    title: '美食博主被前员工曝光使用过期食材',
    category: '博主反差',
    description: '前员工晒出多张后厨照片，卫生状况堪忧',
    views: '1560万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20artistic%20still%20life%20with%20deep%20burgundy%20and%20shadow%20tones%2C%20dramatic%20single%20light%20source%20creating%20tension%2C%20contemporary%20editorial%20style%2C%20mysterious%20and%20unsettling%20atmosphere%2C%20clean%20composition%20with%20negative%20space%2C%20conceptual%20visual%20for%20revelation%20and%20exposure%2C%20no%20text%20or%20people&width=600&height=600&seq=daily-04&orientation=squarish',
  },
  {
    id: 'dc-5',
    title: '某带货主播涉嫌虚假宣传被市监局立案',
    category: '网红塌房',
    description: '宣称"七天美白"产品实为普通护肤品',
    views: '890万',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20with%20stark%20contrast%20between%20bright%20white%20and%20deep%20crimson%2C%20clean%20geometric%20division%20suggesting%20truth%20versus%20deception%2C%20editorial%20art%20direction%2C%20dramatic%20lighting%20creating%20sharp%20shadows%2C%20sophisticated%20conceptual%20visual%2C%20modern%20and%20bold%20composition%2C%20no%20text%20or%20lettering&width=600&height=600&seq=daily-05&orientation=squarish',
  },
  {
    id: 'dc-6',
    title: '健身博主身材造假，P图前后对比太离谱',
    category: '博主反差',
    description: '网友逐帧分析视频，发现多处修图痕迹',
    views: '730万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20split%20composition%20of%20soft%20warm%20tones%20and%20harsh%20dark%20shadows%2C%20glitch-inspired%20geometric%20distortion%2C%20contemporary%20editorial%20photography%20style%2C%20dramatic%20contrast%20suggesting%20before%20and%20after%20transformation%2C%20moody%20atmospheric%20quality%2C%20no%20text%20or%20people%20visible&width=600&height=600&seq=daily-06&orientation=squarish',
  },
];

export const hotGossipArticles = [
  {
    id: 'hg-1',
    title: '娱乐圈"好男人"人设崩塌，深夜与神秘女子同回酒店',
    category: '网红塌房',
    tag: '新',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20artistic%20composition%20with%20deep%20burgundy%20and%20charcoal%20tones%2C%20blurred%20city%20night%20lights%20creating%20bokeh%20effect%2C%20dramatic%20noir-inspired%20lighting%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20mysterious%20and%20alluring%20atmosphere%2C%20sophisticated%20visual%20for%20entertainment%20gossip%2C%20no%20recognizable%20people%20or%20text&width=600&height=800&seq=hot-01&orientation=portrait',
  },
  {
    id: 'hg-2',
    title: '某带货一哥被税务部门追缴税款及罚款共计2.3亿',
    category: '网红塌房',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20with%20stark%20contrast%20of%20bright%20golden%20light%20against%20deep%20shadow%2C%20clean%20geometric%20forms%20suggesting%20financial%20themes%2C%20editorial%20art%20direction%2C%20dramatic%20high-contrast%20lighting%2C%20sophisticated%20and%20serious%20visual%20tone%2C%20warm%20metallic%20accents%20on%20dark%20background%2C%20no%20text%20or%20people&width=600&height=800&seq=hot-02&orientation=portrait',
  },
  {
    id: 'hg-3',
    title: '网红圈再爆代写丑闻，多位博主文案出自同一团队',
    category: '每日大赛',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20overlapping%20translucent%20papers%20in%20warm%20cream%20and%20shadow%20tones%2C%20layered%20geometric%20forms%20suggesting%20documentation%2C%20contemporary%20editorial%20style%2C%20soft%20diffused%20lighting%20from%20above%2C%20intellectual%20and%20investigative%20visual%20mood%2C%20no%20text%20or%20people&width=600&height=800&seq=hot-03&orientation=portrait',
  },
  {
    id: 'hg-4',
    title: '知名美妆博主被扒学历造假，实际仅为初中学历',
    category: '博主反差',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20artistic%20composition%20with%20fractured%20warm%20coral%20tones%20against%20dark%20background%2C%20broken%20geometric%20shapes%20suggesting%20shattered%20facade%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20moody%20atmospheric%20lighting%2C%20conceptual%20visual%20of%20deception%20and%20truth%2C%20no%20text%20or%20people&width=600&height=800&seq=hot-04&orientation=portrait',
  },
];

export const trendingTopics = [
  { id: 'tt-1', title: '网红直播翻车合集', count: '2.3亿讨论' },
  { id: 'tt-2', title: '博主真实颜值VS精修', count: '1.8亿讨论' },
  { id: 'tt-3', title: '娱乐圈塌房时间线', count: '1.5亿讨论' },
  { id: 'tt-4', title: '带货主播虚假宣传', count: '9800万讨论' },
  { id: 'tt-5', title: '网红情侣分手内幕', count: '7600万讨论' },
  { id: 'tt-6', title: '博主学历造假事件', count: '6200万讨论' },
  { id: 'tt-7', title: '直播带货售后维权', count: '5100万讨论' },
  { id: 'tt-8', title: '网红圈代笔产业链', count: '4300万讨论' },
];

export const platformStats = {
  totalArticles: '12,860',
  dailyUpdates: '200+',
  monthlyVisitors: '3800万',
  totalComments: '5.6亿',
};

export const userReviews = [
  {
    id: 'ur-1',
    username: '吃瓜不嫌事大',
    handle: '@chigua_001',
    avatarColor: 'bg-primary-300',
    content: '"这个网站更新速度真的绝了，每次有大瓜都是第一时间推送，比微博还快！已经推荐给所有同事了，一起吃瓜才是真快乐。"',
  },
  {
    id: 'ur-2',
    username: '深夜冲浪选手',
    handle: '@night_surfer',
    avatarColor: 'bg-accent-400',
    content: '"以前到处翻微博知乎贴吧找瓜吃，现在一个网站全搞定，信息整合得太好了，吃瓜效率直接拉满。"',
  },
  {
    id: 'ur-3',
    username: '理性吃瓜群众',
    handle: '@lixing_2026',
    avatarColor: 'bg-secondary-400',
    content: '"内容很全面，但是希望有些爆料能加一下信息来源标注，这样更有可信度。整体来说是目前用过最好的吃瓜平台。"',
  },
  {
    id: 'ur-4',
    username: '八卦研究所所长',
    handle: '@bagua_director',
    avatarColor: 'bg-primary-400',
    content: '"每日大赛栏目太有意思了，每天打开都能看到新鲜的瓜，编辑部真的很会选题，标题取得也很有水平，让人忍不住点进去。"',
  },
  {
    id: 'ur-5',
    username: '摸鱼达人小王',
    handle: '@moyu_wang',
    avatarColor: 'bg-accent-500',
    content: '"上班摸鱼必备网站！界面清爽没广告，加载还快，老板以为我在看正经新闻，实际我在快乐吃瓜哈哈哈。"',
  },
  {
    id: 'ur-6',
    username: '重度网瘾少女',
    handle: '@net_girl_99',
    avatarColor: 'bg-secondary-300',
    content: '"第一次发现这个网站的时候刷了一整个通宵，太好看了根本停不下来。就是希望能出个App版，躺床上刷更方便。"',
  },
];